import { render, staticRenderFns } from "./draftBoxPannel.vue?vue&type=template&id=34db0037"
import script from "./draftBoxPannel.vue?vue&type=script&lang=js"
export * from "./draftBoxPannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports